export const POPUP_STORAGE_KEY = 'AuroraTheme-Popup'

export const POPUP_CLASSNAMES = {
  active: 'popup--active',
  closing: 'popup--closing',
  success: 'popup--success',
}
